const LEAD_PAYWALL_TYPES = new Set(['Download', 'Webinar']);

/**
 * Download and Webinar paywalls collect a lead without gating the page.
 * Article paywalls (Basler ID / form) keep blurring and truncating content.
 */
export function isLeadPaywall(entry: unknown): boolean {
  if (!entry || typeof entry !== 'object') {
    return false;
  }

  const paywallType = (entry as { fields?: { paywallType?: unknown } }).fields
    ?.paywallType;

  return typeof paywallType === 'string' && LEAD_PAYWALL_TYPES.has(paywallType);
}
